import { render, staticRenderFns } from "./RolesManagement.vue?vue&type=template&id=232b066a&scoped=true&"
import script from "./RolesManagement.vue?vue&type=script&lang=js&"
export * from "./RolesManagement.vue?vue&type=script&lang=js&"
import style0 from "./RolesManagement.vue?vue&type=style&index=0&id=232b066a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232b066a",
  null
  
)

export default component.exports